import config from 'config';
import type { MemoryTracker } from 'types/memoryTracker';
import { LINUX, MAC, MEMORY_BROWSER_EXTENSION, WINDOWS } from './known-apps';

export const WindowsMemoryTracker: MemoryTracker = {
  id: WINDOWS,
  name: 'Memory for Windows',
  description: 'Capture the time you spend in your apps and browser',
  action: 'Download',
  downloadLink: config.apps.memoryWindowsTrackerUrl,
  supportLink: config.apps.memoryWindowsTrackerSupportUrl,
};

export const MacMemoryTracker: MemoryTracker = {
  ...WindowsMemoryTracker,
  id: MAC,
  name: 'Memory for Mac',
  downloadLink: config.apps.memoryMacTrackerUrl,
  supportLink: config.apps.memoryMacTrackerSupportUrl,
};

export const LinuxMemoryTracker: MemoryTracker = {
  ...WindowsMemoryTracker,
  id: LINUX,
  name: 'Memory for Linux',
  downloadLink: config.apps.memoryLinuxTrackerUrl,
  supportLink: config.apps.memoryLinuxTrackerSupportUrl,
};

export const ChromeExtensionMemoryTracker: MemoryTracker = {
  id: MEMORY_BROWSER_EXTENSION,
  name: 'Memory for Chrome',
  description: 'Capture the time you spend in your browser',
  action: 'Install',
  downloadLink: config.apps.memoryChromeTrackerUrl,
  downloadInNewWindow: true,
  supportLink: config.apps.memoryChromeTrackerSupportUrl,
};
